import HeaderPopoverComponent from './header-popover.component'

const HeaderPopoverModule = angular.module('cdbl.header-popover', [

])
  .component('cdblHeaderPopover', HeaderPopoverComponent)
  .name

export default HeaderPopoverModule
